const DPI = 96;

export function pxToCm(px: number): number {
    if (!px) return 0;
    return Math.round(px * 2.54 / DPI * 100) / 100;
}

export function cmToPx(cm: number): number {
    if (!cm) return 0;
    return Math.round(cm * DPI / 2.54);
}
